import axios from 'axios';
import { createBrowserHistory } from 'history';

const BASE_DEV_URL = process.env.REACT_APP_BASE_API_OVS;
const history = createBrowserHistory();

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const fetchRefreshToken = async () => {
  try {
    const authUrl = process.env.REACT_APP_FINBASE_AUTH_URL || 'https://finbase-api.staging.arth.bz';
    const url = `${authUrl}/api/v1/token/refresh/`;
    const payload = {
      refresh: localStorage.getItem("refreshToken"),
    };
    const response = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (response?.data) {
      const accessToken = response.data?.access;
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("auth_token", accessToken);
      if (response.data?.refresh) {
        localStorage.setItem("refreshToken", response.data.refresh);
      }
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      localStorage.clear();
      history.push("/");
      window.location.reload();
    }
    throw error;
  }
};

const axiosHttp = axios.create({
  baseURL: `${BASE_DEV_URL}`,
});

axiosHttp.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    const tenantId = localStorage.getItem('tenantId');
    if (accessToken) {
      if (config.headers) {
        config.headers.Token = `Bearer ${accessToken}`;
      }
    }
    if (tenantId) {
      if (config.headers) {
        config.headers['tenant-id'] = tenantId;
      }
    }
    return {
      ...config,
      headers: {
        ...(accessToken !== null && { Token: `Bearer ${accessToken}` }),
        ...(tenantId !== null && { 'tenant-id': tenantId }),
        ...config.headers,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    
    if ((status === 401 || status === 403) && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Token'] = `Bearer ${token}`;
            return axiosHttp(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const data = await fetchRefreshToken();
        const newToken = data.access;
        isRefreshing = false;
        processQueue(null, newToken);
        originalRequest.headers['Token'] = `Bearer ${newToken}`;
        return axiosHttp(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosHttp;
export { fetchRefreshToken };
